import { Pipe, PipeTransform } from '@angular/core';
import { NetworkProvider } from '../providers/network';

@Pipe({
  name: 'isNetworkUser'
})

export class NetworkUserPipe implements PipeTransform {

  constructor(
    private networkProvider: NetworkProvider
  ) { }

  transform(userData: any, cUser: string, clientId: string, type: string): any {
    let userId;
    if (type === 'event') {
      userId = userData.userId;
    } else {
      userId = userData.id;
    }

    return this.networkProvider.getNetworkUser(cUser, userId, clientId)
      .map((items: any) => {
        if (items.length === 0) {
          return true;
        } else {
          switch (items[0].status) {
            // case 'pending':
            //   return cUser === items[0].requestor ? 'sending' : items[0].status;

            default:
              return items[0].status;
          }
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/pipes/network-user.pipe.ts